import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 0,
    phoneNumber: 0,
}

export const loginStepSlice = createSlice({
    name: 'loginStep',
    initialState,
    reducers: {
        changeLoginStep: (state, action) => {
            state.value = action.payload
        },
        setPhoneNumber: (state, action) => {
            state.phoneNumber = action.payload
        }
    },
})

export const { changeLoginStep, setPhoneNumber } = loginStepSlice.actions

export default loginStepSlice.reducer